<mat-card class="sticky-header p-y-0" [style.background-color]="sharedService.blue">
  <mat-card-content>
    <div class="flex flex-col sm:flex-row gap-4 sm:gap-6 justify-start items-start sm:items-center">
      <mat-icon class="medium-icon m-24">description</mat-icon>
      <div class="flex sm:flex-row flex-col flex-1 items-center gap-6">
        <h2 *ngIf="!viewingDetails" class="f-s-20">Your Training Program</h2>
        <h2 *ngIf="viewingDetails" class="f-s-20">{{pageTitle()}}</h2>
        <h2 class="f-s-20 flex items-center gap-2" *ngIf="viewingDetails && trainingProgram.programId"> {{trainingProgram.programId}}
          <button mat-icon-button (click)="sharedService.copyToClipboard(trainingProgram.programId)"
                  matTooltip="Copy to Clipboard" matTooltipShowDelay=800 aria-label="Copy to Clipboard">
            <mat-icon>content_copy</mat-icon>
          </button>
        </h2>
      </div>
      <span *ngIf="saving" class="f-s-16">Saving...</span>
      <mat-spinner *ngIf="saving" color="accent" [diameter]="45" [strokeWidth]="5" aria-label="Loading"></mat-spinner>
      <button mat-raised-button type="button" color="accent" *ngIf="trainingProgram.status !== sharedService.pending &&
                                                                    viewingDetails && trainingPrograms.length > 0" (click)="toggleView()">Close</button>
    </div>
  </mat-card-content>
</mat-card>

<div *ngIf="!viewingDetails" [@slideInOut]>
  <div class="flex w-full flex-col gap-2" style="overflow-x: auto;">
    <div>
      <button *ngIf="canApplyAgain" mat-flat-button type="button" color="primary" (click)="startNewApplication()">Start New Application</button>
    </div>
    <div *ngFor="let program of trainingPrograms">
      <mat-card [style.background]="cardColor" class="w-full md:w-[40%] w-[60%] lg:w-[40%]">
        <mat-card-content>
          <div class="flex flex-col md:flex-row gap-6">
            <div class="flex flex-col gap-2 justify-center flex-1">
              <div class="m-b-0 flex flex-row">
                <span class="w-[40%] md:w-[30%] f-s-16"><strong>Program</strong></span>
                <span class="f-s-16">{{program.programName}}</span>
              </div>
              <div class="m-b-0 flex flex-row justify-start items-center">
                <span class="w-[40%] md:w-[30%] f-s-16"><strong>Program Id</strong></span>
                <span class="f-s-16" id="programId">{{program.programId}}</span>
                <button mat-icon-button (click)="sharedService.copyToClipboard(program.programId)" color="primary" matTooltip="Copy to Clipboard" matTooltipShowDelay=800
                  aria-label="Copy to Clipboard">
                  <mat-icon>content_copy</mat-icon>
                </button>
              </div>
              <div class="flex flex-row justify-start items-center">
                <span class="w-[40%] md:w-[30%] f-s-16"><strong>Status</strong></span>
                <div class="flex flex-col">
                  <span class="f-s-20 f-w-700" [ngClass]="program.status === sharedService.approved? 'text-light-green-600':
                                  (program.status === sharedService.submitted ||
                                   program.status === sharedService.pending ||
                                   program.status === sharedService.underReview)? 'text-orange-900' : 'text-red-900'" *ngIf="program.status != sharedService.submittedForApproval">
                    {{program.status}}
                  </span>
                  <span class="f-s-20 f-w-700" [ngClass]="'text-orange-900'" *ngIf="program.status == sharedService.submittedForApproval">{{sharedService.underReview}}</span>
                  <span *ngIf="program.status === sharedService.approved && hasActiveRevocation" class="f-s-16 text-red-900">Resolution Needed</span>
                </div>
              </div>
              <div *ngIf="program.status === sharedService.submitted || (program.status === sharedService.closed && program.applicationDate)" class="flex flex-row">
                <span class="w-[40%] md:w-[30%] f-s-16"><strong>Date Submitted</strong></span>
                <span class="f-s-16">{{program.applicationDate | date}}</span>
              </div>
              <div *ngIf="program.status === sharedService.closed" class="flex flex-row">
                <span class="w-[40%] md:w-[30%] f-s-16"><strong>Closed Date</strong></span>
                <span class="f-s-16">{{program.closedDate | date}}</span>
              </div>
              <div *ngIf="program.status === sharedService.approved" class="flex flex-row">
                <span class="w-[40%] md:w-[30%] f-s-16"><strong>Date Approved</strong></span>
                <span class="f-s-16">{{program.grantedDate | date}}</span>
              </div>
              <div *ngIf="program.status === sharedService.approved || program.status === sharedService.expired" class="flex flex-row">
                <span class="w-[40%] md:w-[30%] f-s-16"><strong>Expiration Date</strong></span>
                <span class="f-s-16">{{program.expirationDate | date}}</span>
              </div>
              <div *ngIf="program.status === sharedService.approved && program.isRenewal" class="flex flex-row">
                <span class="w-[40%] md:w-[30%] f-s-16"><strong>Date Renewal Approved</strong></span>
                <span class="f-s-16">{{program.renewedDate | date}}</span>
              </div>
              <div class="flex flex-row">
                <span class="w-[40%] md:w-[30%] f-s-16"><strong>Payment Status</strong></span>
                <span [ngClass]="hasPaidApplicationFee(program) ? 'text-light-green-600':  'text-red-900'">
                  <span class="f-s-16">{{getAppliationFeeStatus(program)}}</span>
                </span>
              </div>

              <div *ngIf="hasPaidApplicationFee(program)" class="flex flex-row">
                <span class="w-[40%] md:w-[30%] f-s-16"><strong>Payment Cleared</strong></span>
                <span class="f-s-16">{{getAppliationFeeCleared(program)}}</span>
              </div>

            </div>
            <div class="flex flex-col gap-2 justify-start items-start">
              <button *ngIf="program.status !== sharedService.pendingRenewal && program.status !== sharedService.renewalSubmitted && !program.isRenewal" mat-stroked-button type="button"
                color="primary" (click)="editApplication(program)">
                <div *ngIf="showEditLoading" class="flex flex-row gap-2">
                  <span>Loading</span>
                  <mat-spinner color="accent" [diameter]="25" [strokeWidth]="5" aria-label="Loading"></mat-spinner>
                </div>
                <span *ngIf="!showEditLoading && program.status != 'Pending'">View</span>
                <span *ngIf="!showEditLoading && program.status == 'Pending'">Edit</span>
              </button>
              <button *ngIf="program.isRenewal" mat-flat-button type="button" color="primary" (click)="viewRenewal(program)">
                <div *ngIf="showEditLoading" class="flex flex-row gap-2">
                  <span>Loading</span>
                  <mat-spinner color="accent" [diameter]="25" [strokeWidth]="5" aria-label="Loading"></mat-spinner>
                </div>
                <span *ngIf="program.status === sharedService.pendingRenewal">Continue Renewal</span>
                <span *ngIf="program.status !== sharedService.pendingRenewal">View</span>
              </button>
              <button *ngIf="program.canRenew && !hasRenewal(program) && program.status == sharedService.approved && !startedRenewal" mat-flat-button type="button" color="accent"
                (click)="createRenewal(program)">
                <span>Start Renewal</span>
              </button>
              <button *ngIf="program.status == 'Submitted'" mat-flat-button type="button" color="accent" (click)="requestWithdraw(program)">Request Withdraw
              </button>
              <button *ngIf="program.status == 'Approved'" mat-flat-button type="button" color="accent" (click)="requestSurrender(program)">Request Surrender
              </button>
              <button *ngIf="program.status === sharedService.approved && hasActiveRevocation" mat-stroked-button type='button' color="warn" (click)="viewRevocation()">Resolution</button>
              <a *ngIf="hasPendingFee(program)" mat-stroked-button type="button" color="warn" routerLink="/payments">Pay Fee</a>
              <button *ngIf="program.status === sharedService.approved" mat-flat-button type="button" color="primary" (click)="viewApprovalSummary(program)">Print Curriculum Approval</button>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
</div>

<div *ngIf="viewingDetails">
  <div class="flex flex-col gap-2">
    <mat-stepper class="readable-stepper" [orientation]="sharedService.isMobile? 'vertical' : 'horizontal'" #trainingStepper [selectedIndex]="step" (selectionChange)="changeStep($event)">

      <mat-step [stepControl]="startingForm">
        <ng-template matStepLabel>
          <span matTooltip="Getting Started" matTooltipPosition="below" [matTooltipShowDelay]="500">Getting Started</span>
        </ng-template>

        <div *ngIf="trainingPrograms.length === 0 && showStartButton" class="m-b-8">
          <button mat-flat-button type="button" color="primary" (click)="startApplication()">Start Application</button>
        </div>

        <div *ngIf="!programLocked" class="flex flex-col gap-4 w-full lg:w-[70%]">
          <span *ngIf="sharedService.tablet" class="f-s-18">Getting Started</span>
          <div class="w-full lg:w-[80%] f-s-20">
            <span *ngIf="!trainingProgram.isRenewal">
              Thank you for your interest in applying for psilocybin facilitator training program curriculum approval
              using the Oregon Psilocybin Services Training Program, Licensing, and Compliance system (TLC).
            </span>
            <span *ngIf="trainingProgram.isRenewal">
              Thank you for your interest in applying to renew your psilocybin facilitator training program curriculum approval
              using the Oregon Psilocybin Services Training Program, Licensing, and Compliance system (TLC).
            </span>
          </div>

          <div class="w-full lg:w-[80%]">
            <span>
              Please note, the <strong>Responsible Party</strong> for the training program should complete and sign this application.
              The Responsible Party must be an individual with legal authority to act on behalf of the program and
              who is legally responsible for the program. This person will also serve as the training program's
              primary contact during the training program application process and while the program is approved.
            </span>
          </div>

          <div class="w-full lg:w-[80%]">
            <span>
              When you click the continue button at the bottom of this page, you will proceed to the training program application.
              The application automatically saves in TLC. You may exit the application and come back later to complete and submit the application, if needed.
            </span>
          </div>

          <span>The completed application packet contains the following:</span>

          <mat-list>
            <mat-list-item style="height: auto;" class="m-t-8">
              <div class="flex flex-row gap-4 w-full lg:w-[80%]">
                <span>
                  <strong>*</strong>
                </span>
                <span class="w-full lg:w-[80%]">
                  Completed and signed training program application
                </span>
              </div>
            </mat-list-item>
            <mat-list-item style="height: auto;" class="m-t-8">
              <div class="flex flex-row gap-4 w-full lg:w-[80%]">
                <span>
                  <strong>*</strong>
                </span>
                <span class="w-full md:w-[80%]">
                  Copy of training program curriculum uploaded into the application when prompted
                </span>
              </div>
            </mat-list-item>
            <mat-list-item style="height: auto;" class="m-t-8">
              <div class="flex flex-row gap-4 w-full lg:w-[80%]">
                <span>
                  <strong>*</strong>
                </span>
                <span class="w-full md:w-[80%]">
                  Completed curriculum worksheet in TLC
                </span>
              </div>
            </mat-list-item>
            <mat-list-item style="height: auto;" class="m-t-8">
              <div class="flex flex-row gap-4 w-full lg:w-[80%]">
                <span>
                  <strong>*</strong>
                </span>
                <span *ngIf="!trainingProgram.isRenewal" class="w-full md:w-[80%]">
                  $500 Non-refundable Training Program Application Fee
                </span>
                <span *ngIf="trainingProgram.isRenewal" class="w-full md:w-[80%]">
                  $500 Non-refundable Training Program renewal Application Fee
                </span>
              </div>
            </mat-list-item>
            <mat-list-item style="height: auto;" class="m-t-8">
              <div class="flex flex-row gap-4 w-full lg:w-[80%]">
                <span>
                  <strong>*</strong>
                </span>
                <span class="w-full md:w-[80%]">
                  Payment Remittance Form (payment must clear before application will be reviewed)
                </span>
              </div>
            </mat-list-item>
          </mat-list>

          <span>Important Notes:</span>

          <mat-list>
            <mat-list-item style="height: auto;" class="m-t-8">
              <div class="flex flex-row gap-4 w-full lg:w-[80%]">
                <span>
                  <strong>*</strong>
                </span>
                <span class="w-full md:w-[80%]">
                  There can only be one active training program application per registered account
                </span>
              </div>
            </mat-list-item>
            <mat-list-item style="height: auto;" class="m-t-8">
              <div class="flex flex-row gap-4 w-full lg:w-[80%]">
                <span>
                  <strong>*</strong>
                </span>
                <span class="w-full md:w-[80%]">
                  Please review each section of the application to ensure it is complete
                </span>
              </div>
            </mat-list-item>
            <mat-list-item style="height: auto;" class="m-t-8">
              <div class="flex flex-row gap-4 w-full lg:w-[80%]">
                <span>
                  <strong>*</strong>
                </span>
                <span class="w-full md:w-[80%]">
                  Please provide proof that the training program has received and continues to hold any approvals required from the Higher Education Coordinating Commission (HECC)
                </span>
              </div>
            </mat-list-item>
            <mat-list-item style="height: auto;" class="m-t-8">
              <div class="flex flex-row gap-4 w-[80%]">
                <span>
                  <strong>*</strong>
                </span>
                <span *ngIf="!trainingProgram.isRenewal" class="w-full md:w-[80%]">
                  Toward the end of the application, a fee page will describe how to submit the application fee
                </span>
                <span *ngIf="trainingProgram.isRenewal" class="w-full md:w-[80%]">
                  Toward the end of the application, a fee page will describe how to submit the renewal application fee
                </span>
              </div>
            </mat-list-item>
            <mat-list-item style="height: auto;" class="m-t-8">
              <div class="flex flex-row gap-4 w-full lg:w-[80%]">
                <span>
                  <strong>*</strong>
                </span>
                <span *ngIf="showNewIncompleteDates(trainingProgram.applicationDate)" class="w-full md:w-[80%]">
                  <strong>Paid Application Packets</strong>: <u><em>Completed application packets</em></u> will be reviewed by OPS to ensure all training program information
                  is provided and the curriculum meets the requirements in OAR 333-333-3005 to 333-333-3090. Upon review, if OPS determines
                  your curriculum is insufficient (example: missing required curriculum modules), we will notify you to give you an
                  opportunity to provide the missing information. You will have 30 days from the initial date you are notified to provide
                  the information necessary for your curriculum to be sufficient or your application will be denied. When OPS receives
                  <u><em>incomplete application packets</em></u> (example: no curriculum is attached), OPS will notify you to give you an opportunity
                  to make your application complete. You have 30 days from the initial date you are notified to complete your application or it will be closed
                </span>
                <span *ngIf="!showNewIncompleteDates(trainingProgram.applicationDate)" class="w-full md:w-[80%]">
                  <strong>Paid Application Packets</strong>: <u><em>Completed application packets</em></u> will be reviewed by OPS to ensure all training program information
                  is provided and the curriculum meets the requirements in OAR 333-333-3005 to 333-333-3090. Upon review, if OPS determines
                  your curriculum is insufficient (example: missing required curriculum modules), we will notify you to give you an
                  opportunity to provide the missing information. You will have 90 days from the initial date you are notified to provide
                  the information necessary for your curriculum to be sufficient or your application will be denied. When OPS receives
                  <u><em>incomplete application packets</em></u> (example: no curriculum is attached), OPS will notify you to give you an opportunity
                  to make your application complete. You have 90 days from the initial date you are notified to complete your application or it will be closed
                </span>
              </div>
            </mat-list-item>
            <mat-list-item style="height: auto;" class="m-t-8">
              <div class="flex flex-row gap-4 w-full lg:w-[80%]">
                <span>
                  <strong>*</strong>
                </span>
                <span *ngIf="!trainingProgram.isRenewal" class="w-full lg:w-[80%]">
                  <strong>Unpaid Application Packets:</strong> OPS will not review an application packet until the application fee is paid and cleared.
                </span>
                <span *ngIf="trainingProgram.isRenewal" class="w-full lg:w-[80%]">
                  <strong>Unpaid Application Packets:</strong> OPS will not review an application packet until the renewal application fee is paid and cleared.
                </span>
              </div>
            </mat-list-item>
          </mat-list>

          <div class="w-full lg:w-[80%]">
            <strong>Psilocybin facilitator training programs must be licensed by the Higher Education Coordinating Commission (HECC).</strong>
            Under state law, career schools must be licensed by the HECC. See ORS 345.010 to 345.450. A career school is defined in
            state law as “any private proprietary professional, technical, home study, correspondence, business or other school instruction,
            organization or person that offers any instruction or training for the purpose or purported purpose of instructing, training or
            preparing persons for any profession.” ORS 345.010(3). OHA recommends that psilocybin training programs review the licensure
            laws related to career schools and contact the HECC if they have questions. OPS cannot make any determinations about whether
            HECC licensure is required, that is a decision that the HECC must make.
          </div>

          <div class="w-full lg:w-[80%]">
            <strong>For more information about HECC licensure, please see contact information below:</strong>
          </div>

          <div class="w-full lg:w-[80%]">
            <div class="flex flex-col">
              <span><u>For Private Career School License - Exemption Request & Student Complaints</u></span>
              <span [ngStyle]="{'max-width': sharedService.isMobile? '200px': '300px'}" style="word-wrap: break-word; white-space: normal">
                Matthew Altman - Phone (503) 881-2738</span>
              <span>
                <a href="mailto:Matthew.ALTMAN@hecc.oregon.gov">
                  <div class="flex flex-col sm:flex-row gap-2 justify-start items-center">
                    <span>
                      Matthew.ALTMAN&#64;hecc.oregon.gov</span>
                    <mat-icon>email</mat-icon>
                  </div>
                </a>
              </span>
            </div>
          </div>

          <div class="w-full lg:w-[80%]">
            <div class="flex flex-col">
              <span><u>For Private Career School License- New school Licensure</u></span>
              <span [ngStyle]="{'max-width': sharedService.isMobile? '200px': '300px'}" style="word-wrap: break-word; white-space: normal">
                Peter Gertenrich - Phone (503) 551-8236</span>
              <span>
                <a href="mailto:Peter.GERTENRICH@hecc.oregon.gov">
                  <div class="flex flex-col sm:flex-row gap-2 justify-start items-center">
                    <span>
                      Peter.GERTENRICH&#64;hecc.oregon.gov</span>
                    <mat-icon>email</mat-icon>
                  </div>
                </a>
              </span>
            </div>
          </div>

          <div class="w-full lg:w-[80%]">
            <div class="flex flex-col">
              <span><u>For Schools operating without a private career school license- Cease and Desist Letters</u></span>
              <span [ngStyle]="{'max-width': sharedService.isMobile? '200px': '300px'}" style="word-wrap: break-word; white-space: normal">
                Monika Peterson - Phone (503) 507- 8726</span>
              <span>
                <a href="mailto:Monika.PETERSON@state.or.us">
                  <div class="flex flex-col sm:flex-row gap-2 justify-start items-center">
                    <span>
                      Monika.PETERSON&#64;state.or.us</span>
                    <mat-icon>email</mat-icon>
                  </div>
                </a>
              </span>
            </div>
          </div>

          <div class="w-full lg:w-[80%]">
            <span>
              <strong>
                DISCLAIMER: Psilocybin remains a schedule I drug under the federal Controlled Substances Act. Applicants are
                responsible for making their own determinations regarding the legal risks associated with participating in this program.
                The information you provide in your application materials, including applicant and instructor names, is subject to
                disclosure under Oregon's public records laws
              </strong>
            </span>
          </div>
        </div>

        <div *ngIf="programLocked" class="flex flex-col gap-4 w-full lg:w-[70%]">
          <span *ngIf="sharedService.tablet" class="f-s-18">Getting Started</span>
          <span><strong>TRAINING PROGRAMS MUST NOTIFY OREGON PSILOCYBIN SERVICES (OPS) OF ANY
              MATERIAL CHANGES TO THE CURRICULUM AND STAFF IDENTIFIED IN THEIR APPLICATION.</strong>
          </span>

          <span *ngIf="!trainingProgram.isRenewal">
            <u>Changes to Identified Staff</u>
            To make changes to training program identified staff (i.e. responsible party, registered agent, training program director,
            lead educators, and instructors), click continue and you will proceed to the “Edit People” page. Once changes are entered,
            click “Save and Continue” to save changes. When changes are saved, OPS will be notified of the changes.
          </span>

          <span *ngIf="trainingProgram.isRenewal">
            <u>Changes to Identified Staff</u>
            To make changes to training program identified staff (i.e. responsible party, registered agent, training program director,
            lead educators, and instructors), click continue and you will proceed to the “Edit People” page. Once changes are entered,
            click “Save and Continue” to save changes. When changes are saved, OPS will be notified of the changes.
          </span>

          <span *ngIf="!trainingProgram.isRenewal">
            <u>Changes to Address</u>
            To make changes to the Training Program Addresses, please submit a completed Training Program Change of Address Form by attaching it to a message using your TLC portal or
            attaching to an email sent to <a href="mailto:licensing.psilocybin@oha.oregon.gov">licensing.psilocybin&#64;oha.oregon.gov</a>.
            This form can be located here: <a href="https://www.oregon.gov/oha/PH/PREVENTIONWELLNESS/Pages/Psilocybin-Training-Program-Approval.aspx" target="_blank" rel="noreferrer noopener">Changes
              to Address</a>
          </span>

          <span *ngIf="trainingProgram.isRenewal">
            <u>Changes to Address</u>
            To make changes to the Training Program Addresses, please submit a completed Training Program Change of Address Form by attaching it to a message using your TLC portal or attaching
            to an email sent to <a href="mailto:licensing.psilocybin@oha.oregon.gov">licensing.psilocybin&#64;oha.oregon.gov</a>.
            This form can be located here: <a href="https://www.oregon.gov/oha/PH/PREVENTIONWELLNESS/Pages/Psilocybin-Training-Program-Approval.aspx" target="_blank" rel="noreferrer noopener">Changes
              to Address</a>
          </span>

          <span>
            <u>Practicum Update</u>
            To update information about your Training Program's practicum, including content, lead educators, or practicum site, please complete and return the OPS Practicum
            Update Form by attaching it to a message using your TLC portal or attaching it to an email sent to <a
              href="mailto:licensing.psilocybin@oha.oregon.gov">licensing.psilocybin&#64;oha.oregon.gov</a>.
            This form can be located here: <a href="https://www.oregon.gov/oha/PH/PREVENTIONWELLNESS/Documents/Psilocybin-Training-Program-Practicum-Update-Form.pdf" target="_blank"
              rel="noreferrer noopener">Change of Practicum Form</a>
          </span>

          <span>
            <u>Changes to Training Program Curriculum</u>
            To submit a material change to the training program curriculum, click continue to the "Edit Curriculum" and
            "Edit Curriculum Worksheet" pages. Please upload the updated curriculum for review. After the updated
            curriculum is uploaded, be sure to identify and describe the changes to the curriculum in the box provided.
            Proceed to the "Edit Curriculum Worksheet" page by clicking "Save and Continue". Please select the updated
            curriculum from the drop down menu and enter in the new page number references indicating where each required
            module may be found. After entering all page numbers, click "Save and Continue" to save changes.
            When changes are saved, OPS will be notified of the changes. OPS must review and approve curriculum changes which may take several weeks.
          </span>

          <span>
            <u><strong>These changes are not approved until you receive notification from OPS</strong></u>
            All changes related to your training program are not approved until you receive notification from Oregon Psilocybin Services.
            If you have submitted a change and have not received a confirmation of approval, please send a message using your TLC portal, or send an email to
            <a href="mailto:licensing.psilocybin@oha.oregon.gov">licensing.psilocybin&#64;oha.oregon.gov</a> to follow up.
          </span>
        </div>

        <div *ngIf="trainingPrograms.length === 0 && showStartButton" class="m-t-8">
          <button mat-flat-button type="button" color="primary" (click)="startApplication()">Start Application</button>
        </div>
        <div *ngIf="trainingPrograms.length > 0" class="p-t-16 flex flex-row">
          <button mat-raised-button matStepperNext>Continue</button>
        </div>
      </mat-step>

      <mat-step [stepControl]="programInfoForm" *ngIf="trainingPrograms.length > 0">
        <form [formGroup]="programInfoForm">

          <ng-template matStepLabel>
            <span class="text-red-400" *ngIf="!programInfoForm.valid && !programInfoForm.pristine && !programLocked">
              <span>Edit&nbsp;</span>Training Program Information (incomplete)
            </span>
            <span *ngIf="programInfoForm.valid || programInfoForm.pristine || programLocked"><span *ngIf="programLocked">Edit&nbsp;</span>Training Program Information</span>
          </ng-template>

          <div class="flex flex-col">
            <span *ngIf="sharedService.tablet" class="f-s-18 p-b-8">Program Information</span>
            <div class="flex flex-col gap-4">
              <div class="flex flex-col md:flex-row gap-4">
                <mat-form-field class="w-full md:!w-[20%]">
                  <mat-label id="programNameLabel">Program Name</mat-label>
                  <input matInput placeholder="Training Program Name" formControlName="programName" aria-describedby="programNameLabel">
                  <mat-error role="alert" *ngIf="programInfoForm.get('programName').invalid">
                    Error: Please enter a program name
                  </mat-error>
                </mat-form-field>

                <mat-form-field class="w-full md:!w-[20%]">
                  <mat-label>website</mat-label>
                  <input type="url" matInput placeholder="Website" formControlName="website">
                  <mat-error role="alert" *ngIf="programInfoForm.get('website').hasError('required')">
                    Error: Please provide the url to your website
                  </mat-error>
                  <mat-error role="alert" *ngIf="programInfoForm.get('website').hasError('pattern')">
                    Error: URL should be in the form http(s)://www.website.com
                  </mat-error>
                </mat-form-field>

                <div class="flex flex-col justify-start items-start">
                  <span class="f-s-16">Your training program id:</span>
                  <div class="flex flex-row justify-start items-center">
                    <span class="f-s-16" id="programId"><strong>{{trainingPrograms[0].programId}}</strong></span>
                    <button mat-icon-button (click)="sharedService.copyToClipboard(trainingPrograms[0].programId)" color="primary" matTooltip="Copy to Clipboard" matTooltipShowDelay=800
                      aria-label="Copy Program Id Clipboard">
                      <mat-icon>content_copy</mat-icon>
                    </button>
                  </div>
                </div>
                <div class="flex flex-col gap-2 justify-center items-center">
                  <div class="flex flex-row">
                    <mat-checkbox formControlName="continuingEducation">
                      Offering Continuing Facilitator Education Credits
                    </mat-checkbox>
                  </div>
                </div>
              </div>

              <div class="flex flex-col gap-2">
                <span id="registeredLocationLabel" class="f-s-16"><strong>What state, US territory, or freely associated state are you registered to do business in?</strong></span>
                <div>
                  <mat-form-field class="w-full md:!w-[30%]">
                    <mat-label>Registered In</mat-label>
                    <mat-select formControlName="registeredIn" aria-describedby="registeredLocationLabel">
                      <mat-option *ngFor="let state of sharedService.states" value={{state}}>{{state}}</mat-option>
                    </mat-select>
                    <mat-error role="alert" *ngIf="programInfoForm.get('registeredIn').invalid">
                      Error: Please select a state
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>

              <div class="flex flex-col gap-2">
                <span id="sosNumberLabel" class="f-s-16"><strong>Oregon Secretary of State Registration Number</strong></span>
                <div>
                  <mat-form-field class="w-full md:!w-[30%]">
                    <mat-label>Registry Number</mat-label>
                    <input matInput placeholder="Registry Number" formControlName="secretaryofStateNumber" aria-describedby="sosNumberLabel">
                    <mat-error role="alert" *ngIf="programInfoForm.get('secretaryofStateNumber').invalid">
                      Error: Please enter an Oregon Secretary of State Number
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>

            </div>

            <div class="flex flex-col">
              <span id="headquartersAddressLabel" class="f-s-16"><strong>Program Headquarters/Main Office Physical Address</strong></span>
              <div class="flex flex-col md:flex-row gap-4">
                <mat-form-field class="w-full md:!w-[20%]">
                  <input matInput placeholder="Street" formControlName="headquartersStreet" aria-describedby="headquartersAddressLabel">
                  <mat-error role="alert" *ngIf="programInfoForm.get('headquartersStreet').invalid">
                    Error: Please provide a street
                  </mat-error>
                </mat-form-field>

                <mat-form-field class="w-full md:!w-[20%]">
                  <input matInput placeholder="City" formControlName="headquartersCity" aria-describedby="headquartersAddressLabel">
                  <mat-error role="alert" *ngIf="programInfoForm.get('headquartersCity').invalid">
                    Error: Please provide a city
                  </mat-error>
                </mat-form-field>
              </div>

              <div class="flex flex-col md:flex-row gap-4">
                <mat-form-field class="w-full md:!w-[40%]">
                  <mat-label>State/US territory/freely associated state</mat-label>
                  <mat-select formControlName="headquartersState" aria-describedby="headquartersAddressLabel">
                    <mat-option *ngFor="let state of sharedService.states" value={{state}}>{{state}}</mat-option>
                  </mat-select>
                  <mat-error role="alert" *ngIf="programInfoForm.get('headquartersState').invalid">
                    Error: Please select a state
                  </mat-error>
                </mat-form-field>
              </div>

              <div class="flex flex-col md:flex-row gap-4">
                <mat-form-field class="w-full md:!w-[20%]">
                  <input matInput placeholder="Zip" formControlName="headquartersZip" aria-describedby="headquartersAddressLabel">
                  <mat-error role="alert" *ngIf="programInfoForm.get('headquartersZip').hasError('required')">
                    Error: Please provide a zipcode
                  </mat-error>
                  <mat-error role="alert" *ngIf="programInfoForm.get('headquartersZip').hasError('pattern')">
                    Error: Zipcode should match this format: 99999 or 99999-1234
                  </mat-error>
                </mat-form-field>

                <mat-form-field *ngIf="programInfoForm.get('headquartersState').value === 'OR'" class="w-full md:!w-[20%]">
                  <mat-label>County</mat-label>
                  <mat-select formControlName="headquartersCounty" aria-describedby="headquartersAddressLabel">
                    <mat-option>-- None --</mat-option>
                    <mat-option *ngFor="let county of sharedService.counties" value={{county}}>{{county}}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>

            <div class="flex flex-col">
              <div class="flex flex-col md:flex-row gap-6">
                <span id="mailingAddressLabel" class="f-s-16"><strong>Program Headquarters/Main Office Mailing Address</strong></span>
                <mat-checkbox formControlName="mailingIsHeadquarters" (change)="mailingIsSame()">
                  Same as Headquarters
                </mat-checkbox>
              </div>
              <div [@slideInOut] *ngIf="!programInfoForm.get('mailingIsHeadquarters').value" class="flex flex-col">
                <div class="flex flex-col md:flex-row gap-4">
                  <mat-form-field class="w-full md:!w-[20%]">
                    <input matInput placeholder="Street" formControlName="mailingStreet" (blur)="validateMailingStreet()" aria-describedby="mailingAddressLabel">
                    <mat-error role="alert" *ngIf="validateMailingStreet()">
                      Error: Please provide a street
                    </mat-error>
                  </mat-form-field>

                  <mat-form-field class="w-full md:!w-[20%]">
                    <input matInput placeholder="City" formControlName="mailingCity" (blur)="validateMailingCity()" aria-describedby="mailingAddressLabel">
                    <mat-error role="alert" *ngIf="validateMailingCity()">
                      Error: Please provide a city
                    </mat-error>
                  </mat-form-field>
                </div>

                <div class="flex flex-col md:flex-row gap-4">
                  <mat-form-field class="w-full md:!w-[40%]">
                    <mat-label>State/US territory/freely associated state</mat-label>
                    <mat-select formControlName="mailingState" (blur)="validateMailingState()" aria-describedby="mailingAddressLabel">
                      <mat-option *ngFor="let state of sharedService.states" value={{state}}>{{state}}</mat-option>
                    </mat-select>
                    <mat-error role="alert" *ngIf="validateMailingState()">
                      Error: Please provide a state, US territory or freely associated state
                    </mat-error>
                  </mat-form-field>
                </div>

                <div class="flex flex-col md:flex-row gap-4">
                  <mat-form-field class="w-full md:!w-[20%]">
                    <input matInput placeholder="Zip" formControlName="mailingZip" (blur)="validateMailingZip()" aria-describedby="mailingAddressLabel">
                    <mat-error role="alert" *ngIf="validateMailingZip()">
                      Error: Please provide a zipcode
                    </mat-error>
                    <mat-error role="alert" *ngIf="programInfoForm.get('mailingZip').hasError('pattern')">
                      Error: Zipcode should match this format: 99999 or 99999-1234
                    </mat-error>
                  </mat-form-field>

                  <mat-form-field *ngIf="programInfoForm.get('mailingState').value === 'OR'" class="w-full md:!w-[20%]">
                    <mat-label>County</mat-label>
                    <mat-select formControlName="mailingCounty" aria-describedby="mailingAddressLabel">
                      <mat-option>-- None --</mat-option>
                      <mat-option *ngFor="let county of sharedService.counties" value={{county}}>{{county}}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
            </div>

            <div class="flex flex-col">
              <div class="flex flex-col md:flex-row gap-4">
                <span id="facilityAddressLabel" class="f-s-16"><strong>In-Person Class Site Address</strong></span>
                <mat-checkbox formControlName="facilityIsHeadquarters" (change)="facilityIsSame()" *ngIf="!programInfoForm.get('facilityIsMailing').value">
                  Same as Headquarters
                </mat-checkbox>
                <mat-checkbox formControlName="facilityIsMailing" (change)="facilityIsSame()" *ngIf="!programInfoForm.get('facilityIsHeadquarters').value">
                  Same as Mailing
                </mat-checkbox>
              </div>

              <div [@slideInOut] *ngIf="!programInfoForm.get('facilityIsHeadquarters').value &&
                                                          !programInfoForm.get('facilityIsMailing').value" class="flex flex-col">
                <div class="flex flex-col md:flex-row gap-4">
                  <mat-form-field class="w-full md:!w-[20%]">
                    <input matInput placeholder="Street" formControlName="facilityStreet" (blur)="validateFacilityStreet()" aria-describedby="facilityAddressLabel">
                    <mat-error role="alert" *ngIf="validateFacilityStreet()">
                      Error: Please provide a street
                    </mat-error>
                  </mat-form-field>

                  <mat-form-field class="w-full md:!w-[20%]">
                    <input matInput placeholder="City" formControlName="facilityCity" (blur)="validateFacilityCity()" aria-describedby="facilityAddressLabel">
                    <mat-error role="alert" *ngIf="validateFacilityCity()">
                      Error: Please provide a city
                    </mat-error>
                  </mat-form-field>
                </div>

                <div class="flex flex-col md:flex-row gap-4">
                  <mat-form-field class="w-full md:!w-[40%]">
                    <mat-label>State/US territory/freely associated state</mat-label>
                    <mat-select formControlName="facilityState" (blur)="validateFacilityState()" aria-describedby="facilityAddressLabel">
                      <mat-option *ngFor="let state of sharedService.states" value={{state}}>{{state}}</mat-option>
                    </mat-select>
                    <mat-error role="alert" *ngIf="validateFacilityState()">
                      Error: Please provide a state, US territory or freely associated state
                    </mat-error>
                  </mat-form-field>
                </div>

                <div class="flex flex-col md:flex-row gap-4">
                  <mat-form-field class="w-full md:!w-[20%]">
                    <input matInput placeholder="Zip" formControlName="facilityZip" (blur)="validateFacilityZip()" aria-describedby="facilityAddressLabel">
                    <mat-error role="alert" *ngIf="validateFacilityZip()">
                      Error: Please provide a zipcode
                    </mat-error>
                    <mat-error role="alert" *ngIf="programInfoForm.get('facilityZip').hasError('pattern')">
                      Error: Zipcode should match this format: 99999 or 99999-1234
                    </mat-error>
                  </mat-form-field>

                  <mat-form-field *ngIf="programInfoForm.get('facilityState').value === 'OR'" class="w-full md:!w-[20%]">
                    <mat-label>County</mat-label>
                    <mat-select formControlName="facilityCounty" aria-describedby="facilityAddressLabel">
                      <mat-option>-- None --</mat-option>
                      <mat-option *ngFor="let county of sharedService.counties" value={{county}}>{{county}}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>

            </div>
            <mat-card *ngIf="trainingProgram.isRenewal">
              <div class="flex flex-row">
                <div class="flex flex-col gap-2">
                  <mat-checkbox id="trainingProgramInformationCorrect" formControlName="trainingProgramInformationCorrect">
                    <span class="f-s-16">I certify the information provided is true and complete to the best of my knowledge. I understand falsifying an application, supplying misleading information, or withholding
                    information is grounds for denial of my
                    application or revocation of my license.</span>
                  </mat-checkbox>
                  <mat-error role="alert" *ngIf="validateTrainingProgramInformationCorrect()">
                    Error: This is required
                  </mat-error>
                </div>
              </div>
              <div class="flex flex-row">
                <div class="flex flex-col">
                  <mat-form-field>
                    <textarea rows="2" matInput placeholder="Please list any information on this page that is outdated or incorrect, but you are unable to change"
                      formControlName="trainingProgramInformationCorrectReason" aria-describedby="trainingProgramInformationCorrect"></textarea>
                  </mat-form-field>
                  <div class="text-wrap">You are required to submit a Change Request to update the information you listed above. For more information on Change Requests, please see the TLC Home Page,
                    Change Requests section. This is the first page you see when you log into TLC.</div>
                </div>
              </div>
            </mat-card>
          </div>
        </form>

        <div class="p-t-16 flex flex-row gap-2 w-full md:w-1/2">
          <button mat-raised-button matStepperPrevious>Back</button>
          <button mat-raised-button matStepperNext>Save and Continue</button>
          <button mat-raised-button type="button" color="accent" *ngIf="trainingProgram.status !== sharedService.pending" (click)="toggleView()">Close</button>
        </div>

      </mat-step>

      <mat-step [stepControl]="contactsForm" *ngIf="trainingPrograms.length > 0">
        <ng-template matStepLabel>
          <span class="text-red-400" *ngIf="!contactsValid || !facilitatorForm.valid  || (!contactAttestationForm.valid && !programLocked)"><span>Edit&nbsp;</span>People (incomplete)</span>
          <span *ngIf="contactsValid && facilitatorForm.valid && (contactAttestationForm.valid || programLocked)"><span>Edit&nbsp;</span>People</span>
        </ng-template>

        <div class="flex flex-col gap-6 w-full lg:w-[70%]">
          <span *ngIf="sharedService.tablet" class="f-s-18">Program Contacts</span>
          <div class="flex flex-col gap-4 w-full lg:w-[70%]">
            <span class="f-s-20">
              Please provide the following information for the training program:
            </span>

            <div class="w-full lg:w-[80%]">
              <u>Responsible Party</u>: individual must be legally authorized to make decisions and be legally responsible for the training program.
              This person will serve as the primary contact during the training program application process and while the program is approved.
              Providing the name, email address, and phone number for this individual is required. This person may also hold other roles in
              the training program such as Registered Agent or Training Program Director which can be indicated in the application.
            </div>

            <div class="w-full lg:w-[80%]">
              <u>Registered Agent</u>: This individual must be authorized to accept legal service on behalf of the program and must be listed in any
              business registrations as the Registered Agent. Providing the name, email address, and phone number for this individual is required.
            </div>

            <div class="w-full lg:w-[80%]">
              <u>Training Program Director</u>: This individual must be responsible for tracking student progress and have the authority to track student
              enrollment and confer program completion. Providing the name, email address, and phone number for this individual is required.
            </div>

            <div class="w-full lg:w-[80%]">
              <u>Lead Educators</u>: These individuals are responsible for tracking the progress of students throughout the program. They must have
              sufficient experience, knowledge, skills and ability to competently train students in their assigned subject matter.
              They must understand the objectives of the training program and communicate effectively with students. They must demonstrate skill
              in instruction and student supervision. At least two lead educators must be identified for each training program.
              Providing the name, email address, and phone number for this individual is required.
            </div>

            <div class="w-full lg:w-[80%]">
              <u>Instructors</u>: These individuals must have sufficient experience, knowledge, skills, and ability to competently train students
              in their assigned subject matter. They must understand the objectives of the training program and communicate effectively with students.
              They must demonstrate skill in instruction and student supervision. Only instructor names are required in the application.
            </div>


            <form [formGroup]="facilitatorForm" class="flex flex-col">
              <span id="facilitatorInfoLabel">OAR 333-333 requires that beginning September 1, 2025, at least one instructor at a training program must hold a valid facilitator license in order for the training program to be
                approved or reapproved.</span>
              <div class="flex flex-row">
                <mat-form-field class="w-full md:!w-[30%]">
                  <input matInput placeholder="Facilitator Name" formControlName="facilitatorName" (blur)="validateFacilitatorName()" aria-describedby="facilitatorInfoLabel">
                  <mat-error role="alert" *ngIf="facilitatorForm.get('facilitatorName').hasError('required')">
                    Error: Please provide a Facilitator Name
                  </mat-error>
                </mat-form-field>
              </div>

              <div class="flex flex-row">
                <mat-form-field class="w-full md:!w-[30%]">
                  <input matInput placeholder="Facilitator License" formControlName="facilitatorLicense" (blur)="validateFacilitatorLicense()" aria-describedby="facilitatorInfoLabel">
                  <mat-error role="alert" *ngIf="facilitatorForm.get('facilitatorLicense').hasError('required')">
                    Error: Please provide a Facilitator License
                  </mat-error>
                  <mat-error role="alert" *ngIf="facilitatorForm.get('facilitatorLicense').hasError('idNotFound')">
                    Error: The id provided could not be found
                  </mat-error>
                </mat-form-field>
              </div>
            </form>

            <span><strong>Important Note</strong></span>

            <div class="flex flex-row gap-4 w-full lg:w-[80%]">
              <span>*</span>
              <span>You will be required to attest to the requirements met for each role as outlined in OAR 333-333-3020 and 333-333-3030. </span>
            </div>

          </div>

          <span class="text-red-400" *ngIf="!contactsValid">
            You must include: At least 2 Lead Educators, 1 Registered Agent, 1 Training Program Director, 1 Responsible Party, 1 Instructor
          </span>
        </div>

        <div [class]="!sharedService.isMobile? 'm-b-8' : 'm-b-24'" class="flex flex-col md:flex-row gap-4 justify-start items-center">

          <mat-form-field *ngIf="trainingProgram.trainingProgramContacts.length > 0" class="w-full md:!w-[30%]">
            <input matInput (keyup)="filterTable($event, 'contacts')" placeholder="Filter" />
          </mat-form-field>

          <span class="flex-1"></span>

          <button mat-raised-button type="button" color="primary" (click)="addNewContact()">Add Person</button>
        </div>

        <mat-table [dataSource]="dataSource" matSort #sort="matSort" aria-describedby="instructors" class="mat-elevation-z8 p-t-0">
          <ng-container matColumnDef="firstName">
            <mat-header-cell *matHeaderCellDef mat-sort-header>First</mat-header-cell>
            <mat-cell tabindex="0" *matCellDef="let contact">
              <span class="mobile-label">First</span>
              {{ contact.firstName }}
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="lastName">
            <mat-header-cell *matHeaderCellDef mat-sort-header>Last</mat-header-cell>
            <mat-cell tabindex="0" *matCellDef="let contact">
              <span class="mobile-label">Last</span>
              {{ contact.lastName }}
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="title">
            <mat-header-cell *matHeaderCellDef mat-sort-header>Title</mat-header-cell>
            <mat-cell tabindex="0" *matCellDef="let contact">
              <span class="mobile-label">Title</span>
              {{ contact.title }}
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="role">
            <mat-header-cell *matHeaderCellDef>Roles</mat-header-cell>
            <mat-cell tabindex="0" *matCellDef="let contact">
              <span class="mobile-label">Roles</span>
              <div class="flex flex-col">
                <span *ngIf="contact.isDirector">Training Program Director</span>
                <span *ngIf="contact.isResponsible">Responsible Party</span>
                <span *ngIf="contact.isBusinessAgent">Registered Agent</span>
                <span *ngIf="contact.isLeadEducator">Lead Educator</span>
                <span *ngIf="contact.isInstructor">Instructor</span>
              </div>
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="email">
            <mat-header-cell *matHeaderCellDef mat-sort-header>Email</mat-header-cell>
            <mat-cell tabindex="0" *matCellDef="let contact">
              <span class="mobile-label">Email</span>
              <span [ngStyle]="{'max-width': sharedService.isMobile? '130px': '175px'}" style="word-wrap: break-word; white-space: normal">
                {{ contact.email }}
              </span>
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="phone">
            <mat-header-cell *matHeaderCellDef mat-sort-header>Phone</mat-header-cell>
            <mat-cell tabindex="0" *matCellDef="let contact">
              <span class="mobile-label">Phone</span>
              {{ contact.phone | mask: '(000) 000-0000 000000' }}
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="actions">
            <mat-header-cell *matHeaderCellDef>Edit Person</mat-header-cell>
            <mat-cell *matCellDef="let contact">
              <span class="mobile-label">Edit Person</span>
              <div *ngIf="!contact.isBusinessAgent || contactIsAfterOrEqual(contact.dateCreated, trainingProgram.dateCreated)" class="flex flex-row gap-2">
                <button mat-icon-button (click)="editContact(contact)" color="primary" aria-label="Edit Contact">
                  <mat-icon>create</mat-icon>
                </button>
                <button mat-icon-button (click)="deleteContact(contact)" color="warn" aria-label="Delete Contact">
                  <mat-icon>delete</mat-icon>
                </button>
              </div>
            </mat-cell>
          </ng-container>
          <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
          <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
        </mat-table>
        <mat-paginator [pageSizeOptions]="[5, 20, 50]" #paginator="matPaginator">
        </mat-paginator>
        <mat-card *ngIf="trainingProgram.isRenewal">
          <form [formGroup]="contactAttestationForm">
            <div class="flex flex-row">
              <div class="flex flex-col gap-2">
                <mat-checkbox id="peopleCorrect" formControlName="peopleCorrect">
                  <span class="f-s-16">I certify the information provided is true and complete to the best of my knowledge. I understand falsifying an application, supplying misleading information, or withholding
                  information is grounds for denial of my
                  application or revocation of my license.</span>
                </mat-checkbox>
                <mat-error role="alert" *ngIf="validatePeopleCorrect()">
                  Error: This is required
                </mat-error>
              </div>
            </div>
            <div class="flex flex-row">
              <div class="flex flex-col">
                <mat-form-field>
                  <textarea rows="2" matInput placeholder="Please list any information on this page that is outdated or incorrect, but you are unable to change"
                    formControlName="peopleCorrectReason" aria-describedby="peopleCorrect"></textarea>
                </mat-form-field>
                <div class="text-wrap">You are required to submit a Change Request to update the information you listed above. For more information on Change Requests, please see the TLC Home Page,
                  Change Requests section. This is the first page you see when you log into TLC.</div>
              </div>
            </div>
          </form>
        </mat-card>

        <div class="p-t-16 flex flex-row gap-2 w-full md:w-1/2">
          <button mat-raised-button matStepperPrevious>Back</button>
          <button mat-raised-button matStepperNext>Continue</button>
          <button mat-raised-button type="button" color="accent" *ngIf="trainingProgram.status !== sharedService.pending" (click)="toggleView()">Close</button>
        </div>
      </mat-step>

      <mat-step [stepControl]="documentsForm" *ngIf="trainingPrograms.length > 0">
        <ng-template matStepLabel>
          <span class="text-red-400" *ngIf="!curriculumValid || (!documentsForm.pristine && !documentsForm.valid)"><span *ngIf="programLocked">Edit&nbsp;</span>Curriculum (incomplete)</span>
          <span *ngIf="curriculumValid && (documentsForm.pristine || documentsForm.valid)"><span *ngIf="programLocked">Edit&nbsp;</span>Curriculum</span>
        </ng-template>

        <div class="m-t-16 flex flex-col gap-4 w-full md:w-full md:w-full">
          <span *ngIf="sharedService.tablet" class="f-s-18">Curriculum</span>
          <span class="f-s-20">Please provide a copy of your program's complete curriculum</span>
          <span class="text-red-400" *ngIf="!curriculumValid">You must provide a curriculum document</span>

          <input type="file" accept=".doc,.docx,.rtf,.xls,.xlsx,.pdf,.txt,.png,.jpg,.jpeg,.bmp,.mp4" class="file-input" (change)="uploadCurriculum($event)" #curriculumUpload />

          <div class="flex flex-row gap-2">

            <mat-form-field *ngIf="trainingProgram.trainingProgramContacts.length > 0" class="w-full md:!w-[30%]">
              <input matInput (keyup)="filterTable($event, 'documents')" placeholder="Filter" />
            </mat-form-field>

            <span class="flex-1"></span>

            <section *ngIf="uploading">
              <small>Uploading...</small>
              <mat-progress-bar mode="indeterminate" color="warn" aria-label="Uploading File"></mat-progress-bar>
            </section>
            <section *ngIf="downloading">
              <small>Downloading...</small>
              <mat-progress-bar mode="indeterminate" color="warn" aria-label="Downloading File"></mat-progress-bar>
            </section>
            <section *ngIf="deleting">
              <small>Deleting...</small>
              <mat-progress-bar mode="indeterminate" color="warn" aria-label="Deleting File"></mat-progress-bar>
            </section>

            <div>
              <button *ngIf="!programLocked && this.trainingProgram.trainingProgramDocuments.length === 0" type="button" mat-raised-button class="m-8" color="primary" aria-label="Add Curriculum"
                (click)="curriculumUpload.click()">
                Add
                <mat-icon>attach_file</mat-icon>
              </button>
            </div>
            <div>
              <button *ngIf="(programLocked ||
                              trainingProgram.status === sharedService.incomplete ||
                              trainingProgram.status === sharedService.insufficient) &&
                              !hasCurriculumUpdate" type="button" mat-raised-button class="m-8" color="primary" aria-label="Update Curriculum" (click)="openCurriculumUpdateDialog()">
                Submit Updated Curriculum
              </button>
            </div>
          </div>
          <mat-table [dataSource]="documentSource" matSort #documentSort="matSort" aria-describedby="instructors" class="mat-elevation-z8 p-t-0">
            <ng-container matColumnDef="name">
              <mat-header-cell *matHeaderCellDef mat-sort-header><span class="f-s-16">Name</span></mat-header-cell>
              <mat-cell *matCellDef="let document">
                <span class="mobile-label">Name</span>
                <span class="text-indigo-A400 w-full md:w-[30%] f-s-16" style="cursor: pointer;" title="{{document.name}}" (click)="downloadCurriculum(document)">{{document.name.length > 15 ? document.name.substring(0,15) + "..." : document.name}}
                </span>
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="status">
              <mat-header-cell *matHeaderCellDef><span class="f-s-16">Status</span></mat-header-cell>
              <mat-cell *matCellDef="let document">
                <span class="mobile-label">Status</span>
                <span *ngIf="trainingProgram.status !== sharedService.approved">Pending</span>
                <span *ngIf="document.types.includes(curriculumTypeId) && trainingProgram.status === sharedService.approved" class="text-light-green-600 f-s-16">Accepted</span>
                <span *ngIf="document.types.includes(curriculumUpdateTypeId) && trainingProgram.status === sharedService.approved" class="text-orange-900 f-s-16">Pending Approval</span>
                <span *ngIf="document.types.includes(deniedCurriculumTypeId) && trainingProgram.status === sharedService.approved" class="text-red-400 f-s-16">Not Accepted</span>
                <span *ngIf="document.types.includes(deprecatedCurriculumTypeId) && trainingProgram.status === sharedService.approved" class="text-red-400 f-s-16">Inactive</span>
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="comments">
              <mat-header-cell *matHeaderCellDef mat-sort-header><span class="f-s-16">Comments</span></mat-header-cell>
              <mat-cell *matCellDef="let document">
                <div class="flex flex-col lg:flex-row w-full">
                  <span class="mobile-label">Comments</span>
                  <mat-form-field class="flex-1">
                    <textarea matInput rows="2" type="text" [value]="curriculumComments[document.id]" (focusout)="addCurriculumComment(document.id, $event)" class="w-full"></textarea>
                  </mat-form-field>
                </div>
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="actions">
              <mat-header-cell *matHeaderCellDef></mat-header-cell>
              <mat-cell *matCellDef="let document">
                <button *ngIf="trainingProgram.status === sharedService.pending" mat-mini-fab class="m-8" color="warn" aria-label="Delete Curriculum" (click)="deleteCurriculum(document)">
                  <mat-icon>delete</mat-icon>
                </button>
              </mat-cell>
            </ng-container>
            <mat-header-row *matHeaderRowDef="documentColumns"></mat-header-row>
            <mat-row *matRowDef="let row; columns: documentColumns"></mat-row>
          </mat-table>
          <mat-paginator [pageSizeOptions]="[5, 20, 50]" #documentPaginator="matPaginator">
          </mat-paginator>

          <form [formGroup]="documentsForm">
            <div class="flex flex-col gap-2">

              <mat-checkbox formControlName="curriculumHoursAssertion">
                <span class="f-s-16">
                I certify the proposed hours of instruction meet the requirements of OAR 333-333-3050.
                </span>
              </mat-checkbox>
              <mat-error role="alert" *ngIf="documentsForm.get('curriculumHoursAssertion').hasError('requiredTrue')">
                Error: Attestation Required
              </mat-error>

              <mat-checkbox formControlName="curriculumModulesAssertion">
                <span class="f-s-16">
                I certify the proposed course modules contain the content required by OAR 333-333-3060.
                </span>
              </mat-checkbox>
              <mat-error role="alert" *ngIf="documentsForm.get('curriculumModulesAssertion').hasError('requiredTrue')">
                Error: Attestation Required
              </mat-error>

              <mat-checkbox formControlName="curriculumPracticumAssertion">
                <span class="f-s-16">
                I certify the proposed practicum meets the requirements of OAR 333-333-3070.
                </span>
              </mat-checkbox>
              <mat-error role="alert" *ngIf="documentsForm.get('curriculumPracticumAssertion').hasError('requiredTrue')">
                Error: Attestation Required
              </mat-error>

              <mat-checkbox formControlName="curriculumAcceleratedAssertion">
                <span class="f-s-16">
                I understand the requirements for accelerated training hours outlined in OAR 333-333-3080.
                </span>
              </mat-checkbox>
              <mat-error role="alert" *ngIf="documentsForm.get('curriculumAcceleratedAssertion').hasError('requiredTrue')">
                Error: Attestation Required
              </mat-error>

              <mat-checkbox formControlName="curriculumNoticeAssertion">
                <span class="f-s-16">
                I understand training programs must notify Oregon Psilocybin Services of any material changes
                to the curriculum and staff identified in their application.
                </span>
              </mat-checkbox>
              <mat-error role="alert" *ngIf="documentsForm.get('curriculumNoticeAssertion').hasError('requiredTrue')">
                Error: Attestation Required
              </mat-error>

            </div>
          </form>
        </div>
        <span class="flex-1"></span>
        <div *ngIf="trainingProgram.isRenewal">
          <form [formGroup]="documentsForm">
            <div class="flex flex-row">
              <div class="flex flex-col gap-2">
                <mat-checkbox formControlName="curriculumCorrect">
                  <span class="f-s-16">I certify the information provided is true and complete to the best of my knowledge. I understand falsifying an application, supplying misleading information, or
                  withholding information is grounds for denial of my application or revocation of my license.</span>
                </mat-checkbox>
                <mat-error role="alert" *ngIf="validateCurriculumCorrect()">
                  Error: This is required
                </mat-error>
              </div>
            </div>
          </form>
        </div>

        <div class="p-t-16 flex flex-row gap-2 w-full md:w-1/2">
          <button mat-raised-button matStepperPrevious>Back</button>
          <button mat-raised-button matStepperNext>Save and Continue</button>
          <button mat-raised-button type="button" color="accent" *ngIf="trainingProgram.status !== sharedService.pending" (click)="toggleView()">Close</button>
        </div>
      </mat-step>

      <mat-step [stepControl]="curriculumPagesForm" *ngIf="trainingPrograms.length > 0">
        <ng-template matStepLabel>
          <span *ngIf="worksheetComplete && !trainingProgram.isRenewal"><span *ngIf="programLocked">Edit&nbsp;</span>Curriculum Worksheet</span>
          <span *ngIf="worksheetComplete && trainingProgram.isRenewal && curriculumWorksheetForm.get('curriculumWorksheetCorrect').value"><span *ngIf="programLocked">Edit&nbsp;</span>Curriculum
            Worksheet</span>
          <span *ngIf="!worksheetComplete || (trainingProgram.isRenewal && !curriculumWorksheetForm.get('curriculumWorksheetCorrect').value)" class="text-red-400"><span
              *ngIf="programLocked">Edit&nbsp;</span>Curriculum Worksheet (Incomplete)</span>
        </ng-template>
        <div class="flex flex-col gap-6">
          <span *ngIf="sharedService.tablet" class="f-s-18">Curriculum Worksheet</span>
          <div class="flex flex-col md:flex-row gap-6">
            <span class="f-s-20 w-[70%]">Please provide the page references from your curriculum where each required module can be found.
            </span>
          </div>

          <div *ngIf="activeDocuments.length > 1" class="flex flex-col gap-2">
            <span class="f-s-20">Select A Curriculum</span>
            <div>
              <mat-form-field class="w-full md:!w-[25%]">
                <mat-label>Select Curriculum</mat-label>
                <mat-select [(value)]="curriculumId" (selectionChange)="selectCurriculumToReference($event)">
                  <mat-option *ngFor="let document of activeDocuments" [value]="document.id">{{document.name}}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>

          <div *ngFor="let element of curriculumMap; let elementIndex = index" class="flex flex-col w-full">
            <!--Core Elements-->
            <div class="flex flex-col md:flex-row gap-2 justify-start items-center">
              <span><strong>({{elementIndex + 1}})</strong></span>
              <span>{{element.text}}</span>
              <span>{{element.hours}} hours</span>
            </div>
            <!--Sub Sections-->
            <div class="flex flex-row">
              <span class="w-[5%]"></span>
              <div class="flex flex-col w-[80%]">
                <div *ngFor="let subSection of element.subSections; let subSectionIndex = index" class="flex flex-col gap-2">
                  <div class="flex flex-col md:flex-row gap-2 justify-start items-center">
                    <span><strong>({{getIndexLetter(subSectionIndex, false)}})</strong></span>
                    <span>{{subSection.text}}</span>
                    <mat-form-field class="b-y-0 w-full md:!w-[10%]">
                      <input matInput type="text" required [(ngModel)]="curriculumPageKey[subSection.referenceId]" [name]="subSection.referenceId + 'pages'" placeholder="Pages ex: 1 - 5"
                        #ref="ngModel">
                      <mat-error role="alert" *ngIf="ref.errors?.['required']">
                        Error: Please provide a page reference
                      </mat-error>
                    </mat-form-field>
                  </div>
                  <!--Secondary SubSections-->
                  <div class="flex flex-col">
                    <div class="flex flex-row">
                      <span class="w-[5%]"></span>
                      <div class="flex flex-col w-[90%]">
                        <div *ngFor="let secondSubSection of subSection.subSections; let secondaryIndex = index" class="flex flex-col">
                          <div class="flex flex-col md:flex-row gap-2 justify-start items-center w-[70%]">
                            <span><strong>({{getIndexLetter(secondaryIndex, true)}})</strong></span>
                            <span>{{secondSubSection.text}}</span>
                            <mat-form-field class="b-y-0 w-full md:!w-[10%]">
                              <input matInput type="text" required [(ngModel)]="curriculumPageKey[secondSubSection.referenceId]" [name]="secondSubSection.referenceId + 'pages'"
                                placeholder="Pages ex: 1 - 5" #subRef="ngModel">
                              <mat-error role="alert" *ngIf="subRef.errors?.['required']">
                                Error: Please provide a page reference
                              </mat-error>
                            </mat-form-field>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <span class="flex-1"></span>
        <mat-card *ngIf="trainingProgram.isRenewal">
          <form [formGroup]="curriculumWorksheetForm">
            <div class="flex flex-row">
              <div class="flex flex-col gap-2">
                <mat-checkbox formControlName="curriculumWorksheetCorrect">
                  <span class="f-s-16">I certify the information provided is true and complete to the best of my knowledge. I understand falsifying an application, supplying misleading information, or
                  withholding information is grounds for denial of my application or revocation of my license.</span>
                </mat-checkbox>
                <mat-error role="alert" *ngIf="validateCurriculumWorksheetCorrect()">
                  Error: This is required
                </mat-error>
              </div>
            </div>
          </form>
        </mat-card>
        <div class="p-t-16 flex flex-row gap-2 w-full md:w-1/2">
          <button mat-raised-button matStepperPrevious>Back</button>
          <button mat-raised-button matStepperNext>Save and Continue</button>
          <button mat-raised-button type="button" color="accent" *ngIf="trainingProgram.status !== sharedService.pending" (click)="toggleView()">Close</button>
        </div>
      </mat-step>

      <mat-step [stepControl]="paymentForm" *ngIf="trainingPrograms.length > 0">
        <ng-template matStepLabel>
          <span>Fees</span>
        </ng-template>
        <div class="flex flex-col gap-2 w-full lg:w-1/2">
          <span *ngIf="sharedService.tablet" class="f-s-18">Fees</span>
          <app-payment-notice [id]="trainingProgram.id" [canPay]="false" [entityType]="paymentService.trainingProgramPaymentOption" [renewal]="trainingProgram.isRenewal"></app-payment-notice>
        </div>
        <div class="p-t-16 flex flex-row gap-2 w-full lg:w-1/2">
          <button mat-raised-button matStepperPrevious>Back</button>
          <button mat-raised-button matStepperNext>Continue</button>
          <button mat-raised-button type="button" color="accent" *ngIf="trainingProgram.status !== sharedService.pending" (click)="toggleView()">Close</button>
        </div>
      </mat-step>

      <mat-step [stepControl]="verifyForm" *ngIf="trainingPrograms.length > 0">
        <ng-template matStepLabel>
          <span *ngIf="!programLocked">Review &amp; Submit</span>
          <span *ngIf="programLocked">Review</span>
        </ng-template>

        <div class="flex flex-col gap-4">
          <span *ngIf="sharedService.tablet" class="f-s-18">Review and Submit</span>
          <span class="f-s-20">
            <h3 *ngIf="!programLocked" class="f-s-20">Submit a Facilitator Training Program Curriculum Application</h3>
            <h3 *ngIf="programLocked">Review</h3>
          </span>

          <div class="flex flex-col md:flex-row gap-2">
            <mat-card class="w-full md:w-1/2">
              <mat-card-title>
                <span class="text-red-400" *ngIf="!programInfoForm.valid && !programLocked">Program Information (incomplete)</span>
                <span *ngIf="programInfoForm.valid || programLocked">Program Information</span>
              </mat-card-title>
              <mat-card-content class="f-s-16">
                <div class="flex flex-col gap-2">
                  <div class="flex flex-col md:flex-row gap-4">
                    <span class="flex-1"><strong>Program Name</strong></span>
                    {{trainingProgram.programName}}
                  </div>
                  <div class="flex flex-col md:flex-row gap-4">
                    <span class="flex-1"><strong>Website</strong></span>
                    {{trainingProgram.website}}
                  </div>
                  <div class="flex flex-col md:flex-row gap-2">
                    <span class="flex-1"><strong>Headquarters Address</strong></span>
                    <div class="flex flex-row gap-4">
                      {{trainingProgram.headquartersStreet}}
                      {{trainingProgram.headquartersCity}}
                      {{trainingProgram.headquartersState}}
                      {{trainingProgram.headquartersZip}}
                      {{trainingProgram.headquartersCounty}}
                    </div>
                  </div>
                  <div class="flex flex-col md:flex-row gap-2">
                    <span class="flex-1"><strong>Mailing Address</strong></span>
                    <div *ngIf="!trainingProgram.mailingIsHeadquarters" class="flex flex-row gap-4">
                      {{trainingProgram.mailingStreet}}
                      {{trainingProgram.mailingCity}}
                      {{trainingProgram.mailingState}}
                      {{trainingProgram.mailingZip}}
                      {{trainingProgram.mailingCounty}}
                    </div>
                    <span *ngIf="trainingProgram.mailingIsHeadquarters">Same as Headquarters</span>
                  </div>
                  <div class="flex flex-col md:flex-row gap-2">
                    <span class="flex-1"><strong>In Person Classes</strong></span>
                    <div *ngIf="!trainingProgram.facilityIsHeadquarters && !trainingProgram.facilityIsMailing" class="flex flex-row gap-4">
                      {{trainingProgram.facilityStreet}}
                      {{trainingProgram.facilityCity}}
                      {{trainingProgram.facilityState}}
                      {{trainingProgram.facilityZip}}
                      {{trainingProgram.facilityCounty}}
                    </div>
                    <span *ngIf="trainingProgram.facilityIsHeadquarters">Same as Headquarters</span>
                    <span *ngIf="trainingProgram.facilityIsMailing">Same as Mailing</span>
                  </div>
                </div>
              </mat-card-content>
            </mat-card>

            <mat-card class="w-full md:w-1/2">
              <mat-card-title>
                <div class="flex flex-col md:flex-row gap-4">
                  <span *ngIf="!programLocked && (!curriculumValid || !documentsForm.valid)" class="text-red-400">Curriculum (incomplete)</span>
                  <span *ngIf="programLocked || (curriculumValid && documentsForm.valid)">Curriculum</span>
                  <span *ngIf="!worksheetComplete" class="text-red-400">Curriculum Worksheet is incomplete</span>
                </div>
              </mat-card-title>
              <mat-card-content>
                <div *ngFor="let document of trainingProgram.trainingProgramDocuments">
                  <div class="p-t-8 flex flex-col md:flex-row gap-2 w-full">
                    <span tabindex="0" class="text-indigo-A400 w-full md:w-[40%]" style="cursor: pointer;" (click)="downloadCurriculum(document)" title="{{document.name}}">{{document.name.length > 15 ? document.name.substring(0,15) + "..." : document.name}}
                    </span>
                    <span style="white-space: pre-wrap">{{document.comments}}</span>
                  </div>
                </div>
              </mat-card-content>
            </mat-card>
          </div>

          <div>
            <mat-card>
              <mat-card-title>
                <span class="text-red-400" *ngIf="!contactsValid || !facilitatorForm.valid">People (incomplete)</span>
                <span *ngIf="contactsValid && facilitatorForm.valid">People</span>
              </mat-card-title>
              <mat-table [dataSource]="dataSource" aria-describedby="owners" class="mat-elevation-z8" *ngIf="trainingProgram.trainingProgramContacts.length > 0">
                <ng-container matColumnDef="firstName">
                  <mat-header-cell tabindex="0" *matHeaderCellDef>First Name</mat-header-cell>
                  <mat-cell tabindex="0" *matCellDef="let contact">
                    <span class="mobile-label">First Name</span>
                    {{ contact.firstName }}
                  </mat-cell>
                </ng-container>
                <ng-container matColumnDef="lastName">
                  <mat-header-cell tabindex="0" *matHeaderCellDef>Last Name</mat-header-cell>
                  <mat-cell tabindex="0" *matCellDef="let contact">
                    <span class="mobile-label">Last Name</span>
                    {{ contact.lastName }}
                  </mat-cell>
                </ng-container>
                <ng-container matColumnDef="title">
                  <mat-header-cell tabindex="0" *matHeaderCellDef>Title</mat-header-cell>
                  <mat-cell tabindex="0" *matCellDef="let contact">
                    <span class="mobile-label">Title</span>
                    {{ contact.title }}
                  </mat-cell>
                </ng-container>
                <ng-container matColumnDef="role">
                  <mat-header-cell tabindex="0" *matHeaderCellDef>Roles</mat-header-cell>
                  <mat-cell tabindex="0" *matCellDef="let contact">
                    <span class="mobile-label">Roles</span>
                    <div class="flex flex-col">
                      <span *ngIf="contact.isDirector">Director</span>
                      <span *ngIf="contact.isResponsible">Legally Responsible Authorized Party</span>
                      <span *ngIf="contact.isBusinessAgent">Business Registered Agent</span>
                      <span *ngIf="contact.isLeadEducator">Lead Educator</span>
                      <span *ngIf="contact.isInstructor">Instructor</span>
                    </div>
                  </mat-cell>
                </ng-container>
                <ng-container matColumnDef="email">
                  <mat-header-cell tabindex="0" *matHeaderCellDef>Email</mat-header-cell>
                  <mat-cell tabindex="0" *matCellDef="let contact">
                    <span class="mobile-label">Email</span>
                    <span [ngStyle]="{'max-width': sharedService.isMobile? '130px': '150px'}" style="word-wrap: break-word; white-space: normal">
                      {{ contact.email }}
                    </span>
                  </mat-cell>
                </ng-container>
                <ng-container matColumnDef="phone">
                  <mat-header-cell tabindex="0" *matHeaderCellDef>Phone</mat-header-cell>
                  <mat-cell tabindex="0" *matCellDef="let contact">
                    <span class="mobile-label">Phone</span>
                    {{ contact.phone | mask: '(000) 000-0000 0000' }}
                  </mat-cell>
                </ng-container>
                <ng-containter matColumnDef="certifications">
                  <mat-header-cell tabindex="0" *matHeaderCellDef>Certifications</mat-header-cell>
                  <mat-cell tabindex="0" *matCellDef="let contact">
                    <span class="mobile-label">Certs</span>
                    <div *ngIf="contact.isInstructor" class="flex flex-col">
                      <div *ngFor="let document of contact.trainingProgramContactDocuments">
                        {{ document.name }}
                      </div>
                    </div>
                  </mat-cell>
                </ng-containter>
                <mat-header-row *matHeaderRowDef="reviewColumns"></mat-header-row>
                <mat-row *matRowDef="let row; columns: reviewColumns"></mat-row>
              </mat-table>
            </mat-card>
          </div>


          <form [formGroup]="verifyForm">
            <div class="w-full md:w-1/2">
              <mat-card>
                <mat-card-title>
                  <span>Electronic Signature of Responsible Party</span>
                </mat-card-title>
                <div class="flex flex-col gap-4">

                  <mat-checkbox formControlName="responsibleAttestation" class="p-l-24">
                    <span class="f-s-16">By completing and signing this application, I certify I am the Responsible Party, with legal authority to act on behalf of the training program,
                    am legally responsible for the training program and will serve as the primary contact.</span>
                  </mat-checkbox>

                  <mat-checkbox formControlName="informationAttestation" class="p-l-24">
                    <span class="f-s-16">I certify the information provided in this curriculum worksheet is true and complete to the best of my knowledge.
                    I understand falsifying an application, supplying misleading information, or withholding information is grounds for denial or revocation of approval.</span>
                  </mat-checkbox>

                  <mat-checkbox formControlName="publicRecordAttestation" class="p-l-24">
                    <span class="f-s-16">I understand applicants are responsible for making their own determinations regarding the legal risks associated with participating in this program.</span>
                    I understand much of the information provided in application materials, including applicant and instructor names, is subject to disclosure under
                    Oregon's public records laws.
                  </mat-checkbox>

                  <mat-checkbox formControlName="usAttestation" class="p-l-24">
                    <span class="f-s-16">I understand training programs must be located within the United States, US territories, or freely associated states.</span>
                  </mat-checkbox>

                  <mat-checkbox formControlName="recordKeepingAttestation" class="p-l-24">
                    <span class="f-s-16">I understand the requirements for training program record keeping outlined in OAR 333-333-3040.</span>
                  </mat-checkbox>

                  <mat-checkbox formControlName="programCompletionAttestation" class="p-l-24">
                    <span class="f-s-16">I understand the requirements for training program completion and exams as outlined in OAR 333-333-3090.</span>
                  </mat-checkbox>

                  <mat-checkbox formControlName="termAttestation" class="p-l-24" *ngIf="showFiveYear(trainingProgram.applicationDate)">
                    <span class="f-s-16">I understand training program approval has a term of five years from the date of initial approval. If a training program wishes to be reapproved
                    after that term, a training program must submit a new application, copy of program curriculum, payment,
                    and curriculum worksheet for reapproval at least 30 days prior to their approval expiration.</span>
                  </mat-checkbox>

                  <mat-checkbox formControlName="termAttestation" class="p-l-24" *ngIf="!showFiveYear(trainingProgram.applicationDate)">
                    <span class="f-s-16">I understand training program approval has a term of one year from the date of initial approval. If a training program wishes to be reapproved
                    after that term, a training program must submit a new application, copy of program curriculum, payment,
                    and curriculum worksheet for reapproval at least 30 days prior to their approval expiration.</span>
                  </mat-checkbox>

                  <mat-checkbox formControlName="paymentAssertion" class="p-l-24">
                    <span class="f-s-16">I understand the training program application evaluation fee is non-refundable.</span>
                  </mat-checkbox>

                  <div>
                    <mat-form-field class="w-full md:w-1/2">
                      <mat-label>
                        Electronic Signature of Responsible Party
                      </mat-label>
                      <input matInput placeholder="Signature" formControlName="electronicSignature" class="f-s-16">
                      <mat-error role="alert" *ngIf="verifyForm.get('electronicSignature').invalid">
                        Error: Signature is required
                      </mat-error>
                    </mat-form-field>
                  </div>

                </div>
              </mat-card>
            </div>
          </form>

        </div>

        <div class="p-t-16 flex flex-row gap-2 w-full md:w-1/2">
          <button mat-raised-button matStepperPrevious>Back</button>
          <button mat-raised-button *ngIf="!programLocked" color="primary" [disabled]="!applicationValid()" (click)="submitProgram()">Submit</button>
          <button mat-raised-button type="button" color="accent" *ngIf="trainingProgram.status !== sharedService.pending" (click)="toggleView()">Close</button>
        </div>
      </mat-step>

    </mat-stepper>
  </div>
</div>

<div *ngIf="loadingTrainingProgram">
  <div [ngClass]="{'global-loader': true, 'global-loader-dark': sharedService.darkMode}">
    <h2>Loading</h2>
  </div>
</div>
